import { render, staticRenderFns } from "./AccountUnverified.vue?vue&type=template&id=836ea428"
import script from "./AccountUnverified.vue?vue&type=script&lang=js"
export * from "./AccountUnverified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports